import { Input } from 'almanac-ui/TextInputField/Input'
import { Spinner } from 'common/Spinner/Spinner'
import { FilePathField } from 'components/FilePathField/FilePathField'
import { useLocationPickerProps } from 'components/LocationPicker/hooks/useLocationPicker'
import { useDefaultFolder } from 'hooks/queries/projects/useDefaultFolder'
import { useLastUsedFolder } from 'hooks/queries/projects/useLastUsedFolder'
import { useCurrentFolderStore } from 'hooks/stores/useCurrentFolderStore'
import { AlmanacFile } from 'types'

import Styles from './CampaignNameAndLocation.module.scss'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

interface Props {
  selectedFolder: AlmanacFile | undefined
  campaignName: string | undefined
  setCampaignName: (name: string) => void
  onSelectedFolder: (selectedFolder: AlmanacFile) => void
}

export const CampaignNameAndLocation = ({ selectedFolder, onSelectedFolder, campaignName, setCampaignName }: Props) => {
  const defaultFolder = useDefaultFolder()
  const { isMobile } = useResponsiveDesign()
  const { currentFolder } = useCurrentFolderStore()
  const { lastUsedFolder, isLoading } = useLastUsedFolder()
  let folder = selectedFolder || currentFolder || lastUsedFolder || defaultFolder

  if (folder?.uploads_project) {
    folder = defaultFolder
  }

  const locationPickerProps = useLocationPickerProps({
    folder,
    onSelectedFolder,
  })

  if (!selectedFolder && folder) {
    onSelectedFolder(folder)
  }

  return (
    <div className={Styles.container}>
      <Input
        data-testid="campaign-name-input"
        value={campaignName}
        onChange={(e) => {
          setCampaignName(e.target.value)
        }}
        aria-label="filename"
        name="filename"
        placeholder="Name your campaign"
        size="lg"
      />

      {isLoading ? (
        <div className={Styles.loader}>
          <Spinner />
        </div>
      ) : (
        <FilePathField.LocationPicker {...locationPickerProps} size="lg" isRootDisabled={true} fullWidth={isMobile} />
      )}
    </div>
  )
}
